function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import get from 'lodash/get';
import { useAction } from 'hooks';
import Button from 'components/Form/Button';
import * as actions from '../../../actions';
import messages from '../../../messages';
import App from '../../../../App';
import * as constants from '../../../constants';
import styles from '../DownloadDataModal.pcss';
const BluetoothPairingInstruction = ({ onSetComponent, onSetStyleModifier })=>{
    const formValues = useSelector(App.selectors.formSelector(constants.BLUETOOTH_PIN_FORM));
    const connect = useAction(actions.connectBluetooth);
    const stopListeningBluetooth = useAction(actions.stopListeningBluetooth);
    useEffect(()=>{
        onSetStyleModifier('lg');
        return ()=>{
            onSetStyleModifier(null);
        };
    }, []);
    const onNext = ()=>{
        const discoveredDevice = get(formValues, 'contextData.discoveredDevice');
        connect(discoveredDevice);
        onSetComponent('BluetoothPin');
    };
    const onChangeDeviceType = ()=>{
        stopListeningBluetooth();
        onSetComponent('ChooseConnection');
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: `${styles.modal__content} h-auto`,
        children: [
            /*#__PURE__*/ _jsx("h3", {
                className: "modal__subheader ",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.howToEnablingPairing))
            }),
            /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsxs("ol", {
                    className: `${styles.howTo__list} ${styles['howTo__list--pairing']} row`,
                    children: [
                        /*#__PURE__*/ _jsx("li", {
                            className: `${styles.howTo__list__item} col-6`,
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: styles.howTo__list__item__content,
                                children: [
                                    /*#__PURE__*/ _jsx("p", {
                                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.pairingBluetooth.round3BtnOKBt.first))
                                    }),
                                    /*#__PURE__*/ _jsx("img", {
                                        src: "/assets/svg/Round3BtnOKBt-up.svg",
                                        className: `${styles.instruction__image} mt-4`,
                                        alt: ""
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx("li", {
                            className: `${styles.howTo__list__item} col-6`,
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: styles.howTo__list__item__content,
                                children: [
                                    /*#__PURE__*/ _jsx("p", {
                                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.pairingBluetooth.round3BtnOKBt.second))
                                    }),
                                    /*#__PURE__*/ _jsx("img", {
                                        src: "/assets/svg/Round3BtnOKBt-bt.svg",
                                        className: `${styles.instruction__image} mt-4`,
                                        alt: ""
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Button, {
                type: "submit",
                styleModifier: "primary",
                labelMessage: messages.buttons.next,
                className: `btn--block btn--filled ${styles.pairing__button}`,
                onClick: onNext
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.divider,
                children: /*#__PURE__*/ _jsx("span", {
                    className: styles.divider__text,
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.or))
                })
            }),
            /*#__PURE__*/ _jsx(Button, {
                styleModifier: "transparent",
                labelMessage: messages.buttons.changeDeviceType,
                className: "btn--no-size text--primary m-0",
                onClick: onChangeDeviceType
            })
        ]
    });
};
export default BluetoothPairingInstruction;
